const listaDeProvedores = (state) => {
    return state.items;
}

const listaDeProvedoresDeletados = (state) => {
    return state.itemsDeletados;
}

const loadingProvedores = (state) => {
    return state.carregando
}

export {
    listaDeProvedores,
    listaDeProvedoresDeletados,
    loadingProvedores
}